export enum Currency {
  BRL = "BRL",
  USD = "USD", 
  EUR = "EUR",
  AUD = "AUD",
  CAD = "CAD",
  GBP = "GBP",
  JPY = "JPY",
  CHF = "CHF",
  CNY = "CNY",
  INR = "INR",
  MXN = "MXN",
  ARS = "ARS",
  CLP = "CLP",
  COP = "COP",
  PEN = "PEN",
  UYU = "UYU",
  RUB = "RUB",
  KRW = "KRW",
  SGD = "SGD",
  HKD = "HKD",
  NZD = "NZD",
  NOK = "NOK",
  SEK = "SEK",
  DKK = "DKK",
  PLN = "PLN",
  CZK = "CZK",
  HUF = "HUF",
  TRY = "TRY",
  ZAR = "ZAR",
  ILS = "ILS",
  AED = "AED",
  SAR = "SAR",
  THB = "THB",
  MYR = "MYR",
  PHP = "PHP",
  IDR = "IDR",
  VND = "VND",
}

export const currencyLabels = {
  [Currency.BRL]: "Real Brasileiro (BRL)",
  [Currency.USD]: "Dólar Americano (USD)",
  [Currency.EUR]: "Euro (EUR)", 
  [Currency.AUD]: "Dólar Australiano (AUD)",
  [Currency.CAD]: "Dólar Canadense (CAD)",
  [Currency.GBP]: "Libra Esterlina (GBP)",
  [Currency.JPY]: "Iene Japonês (JPY)",
  [Currency.CHF]: "Franco Suíço (CHF)",
  [Currency.CNY]: "Yuan Chinês (CNY)",
  [Currency.INR]: "Rupia Indiana (INR)",
  [Currency.MXN]: "Peso Mexicano (MXN)",
  [Currency.ARS]: "Peso Argentino (ARS)",
  [Currency.CLP]: "Peso Chileno (CLP)",
  [Currency.COP]: "Peso Colombiano (COP)",
  [Currency.PEN]: "Sol Peruano (PEN)",
  [Currency.UYU]: "Peso Uruguaio (UYU)",
  [Currency.RUB]: "Rublo Russo (RUB)",
  [Currency.KRW]: "Won Sul-Coreano (KRW)",
  [Currency.SGD]: "Dólar de Singapura (SGD)",
  [Currency.HKD]: "Dólar de Hong Kong (HKD)",
  [Currency.NZD]: "Dólar Neozelandês (NZD)",
  [Currency.NOK]: "Coroa Norueguesa (NOK)",
  [Currency.SEK]: "Coroa Sueca (SEK)",
  [Currency.DKK]: "Coroa Dinamarquesa (DKK)",
  [Currency.PLN]: "Zloty Polonês (PLN)",
  [Currency.CZK]: "Coroa Tcheca (CZK)",
  [Currency.HUF]: "Forint Húngaro (HUF)",
  [Currency.TRY]: "Lira Turca (TRY)",
  [Currency.ZAR]: "Rand Sul-Africano (ZAR)",
  [Currency.ILS]: "Shekel Israelense (ILS)",
  [Currency.AED]: "Dirham dos Emirados Árabes Unidos (AED)",
  [Currency.SAR]: "Riyal Saudita (SAR)",
  [Currency.THB]: "Baht Tailandês (THB)",
  [Currency.MYR]: "Ringgit Malaio (MYR)",
  [Currency.PHP]: "Peso Filipino (PHP)",
  [Currency.IDR]: "Rupia Indonésia (IDR)",
  [Currency.VND]: "Dong Vietnamita (VND)",
};
